'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    IoTMapController.$inject = ['$interval', '$q', '$scope', '$state', 'analyticsService', 'iotService'];
    angular.module('app.admin').component('iotMap', {
        require: { app: "^app" },
        template: '<style>\n    .fa.fa-circle.online {\n        color: #5cb85c;\n    }\n    .fa.fa-circle.offline {\n        color: #d9534f;\n    }\n</style><div class="row" translate-namespace="admin.iot-map"><div class="col-lg-12"><div class="form-group"><div class="btn-group btn-group-sm" role="group" aria-label="..."><button type="button" class="btn btn-default" ng-model="$ctrl.form.nodeType" ng-click="$ctrl.onFilterChange()" uib-btn-radio="\'gateways\'" translate>.Gateways</button> <button type="button" class="btn btn-default" ng-model="$ctrl.form.nodeType" ng-click="$ctrl.onFilterChange()" uib-btn-radio="\'devices\'" translate>.Devices</button></div></div></div><div class="col-lg-12"><leaflet lf-center="$ctrl.mapConfig.center" markers="$ctrl.mapMarkers" events="$ctrl.mapConfig.events" width="100%" height="600px"></leaflet></div></div><script type="text/ng-template" id="template/gateway-marker.html"><div translate-namespace="admin.iot-map"> <h3 style="margin-top:5px;"> <small> <i class="fa fa-circle" ng-class="{\'online\': $ctrl.selectedMarker.online , \'offline\': !$ctrl.selectedMarker.online}" aria-hidden="true"></i> </small> {{$ctrl.selectedMarker.name}} </h3> <div> <p> <span ng-if="$ctrl.selectedMarker.online" translate>.Online</span> <span ng-if="!$ctrl.selectedMarker.online" translate>.Offline</span> <span translate>.since</span> {{$ctrl.selectedMarker.since | date: \'dd/MM/yy, HH:mm\'}}. </p> <p> {{$ctrl.selectedMarker.alerts}} <span translate>.Alerts (today)</span> </p> <hr/> </div> <div> <a ui-sref="device-status({id: $ctrl.selectedMarker.id})" translate>.see more</a> </div> </div></script><script type="text/ng-template" id="template/device-marker.html"><div translate-namespace="admin.iot-map"> <h3 style="margin-top:5px;"> <small> <i class="fa fa-circle" ng-class="{\'online\': $ctrl.selectedMarker.online , \'offline\': !$ctrl.selectedMarker.online}" aria-hidden="true"></i> </small> {{$ctrl.selectedMarker.name}} </h3> <div> <p> <span ng-if="$ctrl.selectedMarker.online" translate>.Online</span> <span ng-if="!$ctrl.selectedMarker.online" translate>.Offline</span> <span translate>.since</span> {{$ctrl.selectedMarker.since | date: \'dd/MM/yy, HH:mm\'}}. </p> <p> {{$ctrl.selectedMarker.alerts}} <span translate>.Alerts (today)</span> </p> <hr/> </div> <div> <a ui-sref="device-status({id: $ctrl.selectedMarker.id})" translate>.see more</a> </div> </div></script>',
        controller: IoTMapController,
        controllerAs: '$ctrl'
    });

    function IoTMapController($interval, $q, $scope, $state, analyticsService, iotService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {

            $ctrl.form = new FormModel();

            $ctrl.mapConfig = {
                center: {
                    lat: 35.31603850,
                    lng: 25.07629650,
                    zoom: 11
                },
                events: {
                    markers: {
                        enable: ['popupopen']
                    }
                }
            };

            $scope.$on('leafletDirectiveMarker.popupopen', function (event, args) {
                $ctrl.selectedMarker = args.model;
            });

            $ctrl.gateways = [];
            $ctrl.devices = [];
            $ctrl.mapMarkers = [];

            $ctrl.updater = update();
            $ctrl.updater = $interval(update, 60000, 100);
        };

        $ctrl.$onDestroy = function () {
            $interval.cancel($ctrl.updater);
        };

        $ctrl.onFilterChange = function () {
            $ctrl.mapMarkers = {};

            switch ($ctrl.form.nodeType) {
                case 'gateways':
                    $ctrl.mapMarkers = $ctrl.gateways;
                    break;
                case 'devices':
                    $ctrl.mapMarkers = $ctrl.devices;
                    break;
            }
        };

        /**
         * 
         */
        function update() {
            var to = moment(),
                from = to.clone().startOf('day');

            $q.all({
                gateways: iotService.getGateways(true),
                alertsCount: analyticsService.getAlertsCount(from, to)
            }).then(function (r) {
                $ctrl.gateways = r.gateways;
                $ctrl.devices = _.flatMap(r.gateways, 'devices');

                $ctrl.gatewayAlertsCount = _(r.alertsCount).groupBy('gateway_id').mapValues(function (o) {
                    return _.sumBy(o, 'count');
                }).value();

                $ctrl.deviceAlertsCount = _(r.alertsCount).groupBy('device_id').mapValues(function (o) {
                    return _.sumBy(o, 'count');
                }).value();

                $ctrl.devices = _(r.gateways).flatMap('devices').map(function (o) {
                    return _(o).omit(['gateway']).assign({
                        message: '<div ng-include src="\'template/device-marker.html\'"></div>',
                        getMessageScope: function getMessageScope() {
                            return $scope;
                        },
                        lat: o.latitude,
                        lng: o.longitude,
                        focus: false,
                        alerts: $ctrl.deviceAlertsCount[o.id],
                        icon: {
                            prefix: 'fa',
                            icon: 'fa-desktop',
                            type: 'vectorMarker',
                            iconColor: '#fff',
                            markerColor: o.online ? '#5cb85c' : '#d9534f'
                        }
                    }).value();
                }).keyBy(function (o) {
                    return 'dv' + o.id;
                }).value();

                $ctrl.gateways = _(r.gateways).map(function (o) {
                    return _(o).omit(['devices']).assign({
                        message: '<div ng-include src="\'template/gateway-marker.html\'"></div>',
                        getMessageScope: function getMessageScope() {
                            return $scope;
                        },
                        lat: o.latitude,
                        lng: o.longitude,
                        focus: false,
                        alerts: $ctrl.gatewayAlertsCount[o.id],
                        icon: {
                            prefix: 'fa',
                            icon: 'fa-wifi',
                            type: 'vectorMarker',
                            iconColor: '#fff',
                            markerColor: o.online ? '#5cb85c' : '#d9534f'
                        }
                    }).value();
                }).keyBy(function (o) {
                    return 'gw' + o.id;
                }).value();

                $ctrl.onFilterChange();
            }).catch(function (error) {

                if (error.status === 401) {
                    $state.go('login');
                }

                console.error('Oops, something went wrong!', error);
            });
        }

        /**
         * 
         */

        var FormModel = function FormModel() {
            _classCallCheck(this, FormModel);

            this.nodeType = 'gateways';
            this.deviceType = 'all';
        };
    }
})();